class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.closeTimer = null;

    document.addEventListener('pointerdown', this.onDocumentPointerDown);
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);
    window.clearTimeout(this.closeTimer);
  }

  onDocumentPointerDown(event) {
    if (this.mainDetailsToggle.open && !this.contains(event.target)) this.close();
  }

  onMouseEnter() {
    window.clearTimeout(this.closeTimer);
  }

  onMouseLeave() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      const pointerReturned = this.mainDetailsToggle.matches(':hover');
      const keyboardFocusInside = this.contains(document.activeElement);

      if (!pointerReturned && !keyboardFocusInside) this.close();
    }, 420);
  }

  close() {
    window.clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
